import type { IResolveIntegrationSourceNameProps } from "../types/integration-source";

// NOTE: NSAI-5132 — the display name of the app a file is being pulled from, so
// a fetch row can say "Fetching from Google Drive" instead of leaving the user
// to guess what the client is busy with. Provider names are brands, not copy,
// so they are not i18n keys. The mapping lives here because each client's
// picker list carries its own icon components and therefore cannot be shared
// wholesale — keeping the naming per client made the same label diverge as soon
// as a provider was added or renamed on one side only.
const INTEGRATION_SOURCE_NAMES: Record<string, string> = {
  google_drive: "Google Drive",
  confluence: "Confluence",
  dropbox: "Dropbox",
  nextcloud: "Nextcloud",
  onedrive: "OneDrive",
};

// NOTE: Undefined for anything that is not fetched out of a third-party app (a
// local file) or has no known brand name (a custom connector) — the row falls
// back to a source-less label for those.
export const resolveIntegrationSourceName = ({
  provider,
}: IResolveIntegrationSourceNameProps): string | undefined =>
  INTEGRATION_SOURCE_NAMES[provider];
